module.exports = __webpack_public_path__ + "img/zhyj-1.45b5a863.png";